/** When set on a toast, MasterLayout Toast only shows it on /photodrop (hides fetch etc. errors). */
export const PHOTODROP_DOWNLOAD_TOAST_SCOPE = 'photodrop-download';
/** Wallet pass toasts only show on the QR code page. */
export const QR_WALLET_TOAST_SCOPE = 'qr-wallet';

const state = () => ({
  message: '',
  icon: '',
  color: '',
  scope: null,
  action: null,
  persistent: false,
  // null = no bar. { value: 0-100 } = determinate. { value: null } = indeterminate.
  progress: null,
});

const mutations = {
  set(state, data) {
    state.message = data.message;
    // `icon: null` explicitly suppresses the icon (e.g. progress toasts); otherwise default.
    state.icon =
      data.icon === null
        ? ''
        : data.icon || require('../../../public/assets/icons/toast-check.svg');
    state.color = data.color || 'bg-[#056DFF]';
    if (!data.message) {
      state.scope = null;
      state.action = null;
      state.persistent = false;
      state.progress = null;
    } else {
      state.scope = 'scope' in data ? data.scope : null;
      state.action = data.action || null;
      state.persistent = data.persistent || false;
      // Any new toast without a progress field clears the bar (e.g. success/fail toasts).
      state.progress = 'progress' in data ? data.progress : null;
    }
  },
  // Updates only the message text, leaving icon/color/action/persistent untouched
  setMessage(state, message) {
    state.message = message;
  },
  setProgress(state, progress) {
    state.progress = progress;
  },
};

const actions = {
  show({ commit }, data) {
    const payload = typeof data === 'string' ? { message: data } : data;
    commit('set', payload);
    if (!payload.persistent) {
      setTimeout(() => commit('set', { message: '' }), 5000);
    }
  },

  dismiss({ commit }) {
    commit('set', { message: '' });
  },

  // Updates only the toast message in-place (icon/color/action/persistent unchanged)
  update({ commit }, { message }) {
    commit('setMessage', message);
  },

  // Shows a persistent toast with a progress bar (no icon). `value`: 0-100, or null
  // for an indeterminate bar. Update it live with updateProgress; it is replaced when
  // the next success/error toast is shown.
  showProgress({ commit }, { message, scope = null, value = 0 }) {
    commit('set', {
      message,
      icon: null,
      color: 'bg-[#056DFF]',
      scope,
      persistent: true,
      progress: { value },
    });
  },

  updateProgress({ commit }, { message, value }) {
    if (message !== undefined) commit('setMessage', message);
    commit('setProgress', { value });
  },

  success({ dispatch }, payload) {
    let message = payload;
    let color = 'bg-[#22C55E]';
    let icon = require('../../../public/assets/icons/toast-check.svg');
    let scope = null;

    if (typeof payload === 'object' && payload !== null) {
      message = payload.message;
      color = payload.color || color;
      icon = payload.icon || icon;
      scope = payload.scope ?? null;
    }

    dispatch('show', {
      message,
      color,
      icon,
      scope,
      action: typeof payload === 'object' && payload !== null ? payload.action || null : null,
      persistent: typeof payload === 'object' && payload !== null ? !!payload.persistent : false,
    });
  },

  // Opens the iOS Wallet app (shoebox:// is Wallet's URL scheme); used by toast action buttons.
  openAppleWallet({ dispatch }) {
    window.location.href = 'shoebox://';
    dispatch('dismiss');
  },

  error({ dispatch }, payload) {
    let message = payload;
    let scope = null;
    if (typeof payload === 'object' && payload !== null) {
      message = payload.message;
      scope = payload.scope ?? null;
    }
    dispatch('show', {
      message,
      color: 'bg-[#BE3A34]',
      icon: require('../../../public/assets/icons/alert-triangle.svg'),
      scope,
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
